package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.UserRepository
import com.clany.backoffice.model.UserResponse

import dev.zacsweers.metro.Inject

@Inject
class GetUsersUseCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(page: Int, pageSize: Int, query: String? = null): Result<List<UserResponse>> {
        return userRepository.getUsers(page, pageSize, query)
    }
}
